
<template>
  <div>
    <!-- <header v-if="isWX != 0">
      <i class="iconfont icon-home_location_icon_l" @click="closeHandsel"></i>
      <p>{{routerType == 1?'我要加盟':'如何加盟'}}</p>
    </header>-->
    <h5-header
      v-if="isWX != 0"
      :header-msg="headerMsg"
    ></h5-header>
    <img
      :src="bg_top"
      alt=""
      style="width: 100%"
    />
    <div class='btn-group'>
      <img
        :src="btn_partner"
        alt=""
        @click="topartner"
      />
      <img
        :src="btn_rc"
        alt=""
        @click="torc"
      />
    </div>
    <!-- <div style="height:285px;">
      <div style="position:relative;display:inline-block;">
        <img :src="bg_partner" alt="" style="width:170px;margin-right:11px;">
        <img :src="btn_partner" alt="" style="width:150px;position:absolute;bottom:-15px;left:50%;margin-left:-75px;" @click="topartner">
      </div>
      <div style="position:relative;display:inline-block;">
        <img :src="bg_rc" alt="" style="width:170px">
        <img :src="btn_rc" alt="" style="width:150px;position:absolute;bottom:-15px;left:50%;margin-left:-75px;" @click="torc">
      </div>
    </div> -->
    <!-- <van-tabs
      v-model="active"
      animated
      swipeable
      background="#1163EA"
      line-height="0"
      title-active-color="#fff"
      title-inactive-color="#B0CEFF"
      @click="onClick"
      @change="onClick"
      ref="tabs"
    >
      <van-tab title="邀请朋友加盟" class="tabsA tab_Invite" :disabled="disabled" v-show="showTabs">
        <img src="../../assets/img/join_theme.png" alt="邀请商家入驻可获得商家每笔订单的千分之五赏金" class="banners" />

        <div class="lists">
          <img src="../../assets/img/join_pic2.png" alt />
          <p>成熟明确的战略指导方向</p>
        </div>
        <div class="lists">
          <img src="../../assets/img/join_pic1.png" alt />
          <p>每天给商家带来更高的营业额</p>
        </div>
        <div class="texts">
          <p>申请开店需要哪些材料？</p>
          <p>店内照片，门店照片，营业执照</p>
          <p>提交审核要多久才通过？</p>
          <p>提交申请后，1～3个工作日会有市场经理与您线下联系；如超时未处理，您可拨打客服电话咨询</p>
          <p>无实体店可以加盟吗？</p>
          <p>不可以，加盟必须有线下实体门店，并且需要准备好营业执照等照片</p>
          <p>客服电话</p>
          <p>有任何疑问可拨打客服电话联系（0752-2162293）</p>
        </div>
        <div class="divs bg">
        </div>
      </van-tab>
      <van-tab title="我要加盟" class="tabsA tab_join" ref="tab_join">
        <img src="../../assets/img/join_theme1.png" alt="邀请商家入驻可获得商家每笔订单的千分之五赏金" class="banners2" />

        <div class="lists">
          <img src="../../assets/img/join_pic2.png" alt style="margin-right:6px" />
          <p>
            成熟明确的战略指导方向，每天
            给您带来更高的营业额
          </p>
        </div>
        <div class="lists">
          <img src="../../assets/img/join_pic1.png" alt style="margin-right:6px" />
          <p>
            菜市场线上售卖的新平台，为您
            开拓新时代的商品售卖渠道
          </p>
        </div>
        <div class="lists">
          <img src="../../assets/img/join_pic3.png" alt style="margin-right:6px" />
          <p>
            拥有实战经验丰富的专业运营团
            队，为您的日常经营锦上添花
          </p>
        </div>
        <div class="texts">
          <p>申请开店需要哪些材料？</p>
          <p>店内照片，门店照片，营业执照</p>
          <p>提交审核要多久才通过？</p>
          <p>提交申请后，1～3个工作日会有市场经理与您线下联系；如超时未处理，您可拨打客服电话咨询</p>
          <p>无实体店可以加盟吗？</p>
          <p>不可以，加盟必须有线下实体门店，并且需要准备好营业执照等照片</p>
          <p>客服电话</p>
          <p>有任何疑问可拨打客服电话联系（0752-2162293）</p>
        </div>
        <div class="divs">
        </div>
      </van-tab>
    </van-tabs> -->
    <!-- <van-button
      type="info"
      @click="showPopup"
      color="#2376FF"
      class="btn invite"
    >{{tabIndex == 0?'立即邀请':'立即加盟'}}</van-button> -->
    <!-- <van-popup v-model="show" position="bottom" class="shareModel">
      <p class="shareText">
        邀请商家入驻可获得商家每笔订单的
        <span>{{numbers}}</span>赏金
      </p>
      <div class="shares">
        <p class="shareOther">分享到</p>
        <div class="shareList">
          <div @click="popup('1')">
            <img src="../../assets/img/personal_invite_icon_wechat.png" alt />
            <p>微信</p>
          </div>
          <div @click="popup('2')">
            <img src="../../assets/img/personal_invite_icon_circle.png" alt />
            <p>朋友圈</p>
          </div>
          <div @click="popup('3')">
            <img src="../../assets/img/personal_invite_icon_qq.png" alt />
            <p>QQ好友</p>
          </div>
        </div>
      </div>
      <img src="../../assets/img/share.png" alt style="display:none;" />
      <van-button type="default" class="close" @click="showPopup">取消</van-button>
    </van-popup> -->

    <!-- 微信小程序分享提示遮罩 -->
    <!-- <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper">
        <div class="block">
          <img src="../../assets/img/share_tips.png" alt />
          <div class="btns">我知道了</div>
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>
<script>
import bg_partner from "@/assets/img/bg_partner.png";
import bg_rc from "@/assets/img/bg_rc.png";
import bg_top from "@/assets/img/bg_top.png";
import btn_rc from "@/assets/img/btn_rc.png";
import btn_partner from "@/assets/img/btn_partner.png";
// import { share } from "@/api/join";
export default {
  data() {
    return {
      // active: 0,
      // tabIndex: 0,
      // show: false,
      // showTabs: true,
      // numbers: "",
      // disabled: false,
      // num: 2,
      // routerType: "", //是否从链接进入 0不是，1是
      isWX: "1",
      // showOverlay: false,
      headerMsg: {
        title: "如何加盟",
        url: "",
      },
      bg_partner: bg_partner,
      bg_rc: bg_rc,
      bg_top: bg_top,
      btn_partner: btn_partner,
      btn_rc: btn_rc,
      token: "",
      nikename: "",
      lat: "",
      lng: "",
      areaId: "",
    };
  },
  mounted() {
    // token=${lgstatus.token}&lat=${app.globalData.latitude}&lng=${app.globalData.longitude}&nickname=${lgstatus.nickname}&areaId=${app.globalData.areaId}&phone=${lgstatus.phone}&memberId=${lgstatus.memberId}&cityId=${app.globalData.cityId}`
    this.isWX = this.GetQueryString("wx");
    this.token = this.GetQueryString("token");
    this.nickname = this.GetQueryString("nickname");
    this.lat = this.GetQueryString("lat");
    this.lng = this.GetQueryString("lng");
    this.areaId = this.GetQueryString("areaId");
    this.phone = this.GetQueryString("phone");
    this.memberId = this.GetQueryString("memberId");
    this.cityId = this.GetQueryString("cityId");
    // this.share();
  },
  beforeUpdate() {
    // let types = this.GetQueryString("type");
    // this.routerType = this.GetQueryString("type");
    // this.headerMsg.title = this.routerType == 1?'我要加盟':'如何加盟'
    // this.isWX = this.GetQueryString("wx");
    // if (this.isWX == 0) {
    //   console.log(this.$refs.tabs);
    //   this.$refs.tabs.$el.children[0].style.top = "0";
    //   this.$refs.tabs.$el.children[1].style.marginTop = "49px";
    // }
    // if (types == 1) {
    //   this.disabled = true;
    //   this.showTabs = true;
    //   // this.tabIndex = 1
    //   this.active = 1;
    //   this.$refs.tabs.$refs.nav.style.display = "none";
    //   this.$refs.tabs.$el.children[1].style.marginTop = "42px";
    //   if (this.isWX == 0) {
    //     //console.log(this.$refs.tabs)
    //     this.$refs.tabs.$refs.nav.style.display = "none";
    //     this.$refs.tabs.$el.children[1].style.marginTop = "0";
    //   }
    //   // this.$refs.tabs.$refs.nav.style.background='#2376FF'
    //   // this.$refs.tabs.$refs.nav.children[0].style.display = "none";
    //   // this.$refs.tabs.$refs.nav.children[1].style.display = "none";
    //   // this.$refs.tabs.$refs.nav.children[1].style.background = "#2376FF";
    //   // console.log(this.$refs.tabs.$el.children[1].style)
    // } else {
    //   this.showTabs = true;
    //   this.$refs.tabs.$refs.nav.children[
    //     this.tabIndex == 0 ? 0 : 1
    //   ].style.background = "#2376FF";
    // }
  },
  methods: {
    topartner() {
      window.location.href = this.baseURL + "h5/housestore/#/recruitPartner";
    },
    torc() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
            wx.miniProgram.redirectTo({ url: "/community/pages/goApplyBossApplet/goApplyBossApple" });
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.jumpApplyCeo();
        } else {
          // ios环境
          window.webkit.messageHandlers.jumpApplyCeo.postMessage("");
        }
      }
      // window.location.href =
      //   this.baseURL +
      //   `h5/housestore/#/applyIndex?token=${this.token}&nickname=${this.nickname}&lat=${this.lat}&lng=${this.lng}&areaId=${this.areaId}&phone=${this.phone}&memberId=${this.memberId}&cityId=${this.cityId}`;
    },
    // 获取点击的tabIndex
    // onClick(name, title) {
    //   this.tabIndex = name;
    //   this.$refs.tabs.$refs.nav.children[name].style.background = "#2376FF";
    //   this.$refs.tabs.$refs.nav.children[name == 0 ? 1 : 0].style.background =
    //     "#1163EA";
    //   console.log(name);
    // },

    // 弹窗/路由事件
    // showPopup() {
    //   if (this.tabIndex == 1) {
    //     this.$router.push({
    //       path: "/joinup",
    //       query: {
    //         type: this.GetQueryString("type"),
    //         refereeId: this.GetQueryString("refereeId"),
    //         wx: this.GetQueryString("wx") || "1"
    //       }
    //     }); //跳转
    //     return false;
    //   }
    //   if (this.isWX == 0) {
    //     //微信环境
    //     //小程序环境下逻辑
    //     this.showOverlay = true;
    //   } else {
    //     this.show = !this.show;
    //   }
    // },

    // 分享接口，获取分享所需的参数
    // share() {
    //   share({ userType: "2" }).then(res => {
    //     // console.log(res.content.percent)
    //     let count = res.content.percent.split(".")[1].length;
    //     // console.log(count)
    //     // 千分之百分之换算
    //     switch (count) {
    //       case 3:
    //         this.numbers = res.content.percent * 1000 + "‰ ";
    //         break;
    //       case 2:
    //         this.numbers = res.content.percent * 100 + "% ";
    //         break;
    //       case 1:
    //         this.numbers = res.content.percent * 10 + "% ";
    //         break;
    //       default:
    //         break;
    //     }

    //     // 分享参数
    //     this.desc = res.content.desc;
    //     this.imgUrl = res.content.pic;
    //     this.title = res.content.title;
    //     this.linkUrl = res.content.url;
    //   });
    // },

    //返回事件
    // closeHandsel() {
    //   var ua = window.navigator.userAgent.toLowerCase();
    //   if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //     //微信环境
    //     wx.miniProgram.getEnv(function(res) {
    //       if (res.miniprogram) {
    //         //小程序环境下逻辑
    //       } else {
    //         //非小程序环境下逻辑
    //       }
    //     });
    //   } else {
    //     //非微信环境逻辑
    //     let u = navigator.userAgent,
    //       app = navigator.appVersion;
    //     let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //     let isOS = isAndroid ? true : false;
    //     if (isOS) {
    //       // Android环境
    //       window.Android.closeHandsel();
    //     } else {
    //       // ios环境
    //       window.webkit.messageHandlers.closeHandsel.postMessage("");
    //     }
    //   }
    // },

    // 分享多端集成
    // popup(shareType) {
    //   let linkUrl =
    //       this.linkUrl +
    //       "?type=1&refereeId=" +
    //       this.GetQueryString("refereeId"),
    //     title = this.title,
    //     desc = this.desc,
    //     imgUrl = this.imgUrl;
    //   console.log(linkUrl);
    //   var ua = window.navigator.userAgent.toLowerCase();
    //   if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //     //判断是否是微信环境
    //     //微信环境
    //     wx.miniProgram.getEnv(function(res) {
    //       if (res.miniprogram) {
    //         //小程序环境下逻辑
    //       } else {
    //         //非小程序环境下逻辑
    //       }
    //     });
    //   } else {
    //     //非微信环境逻辑
    //     // console.log(filename);
    //     let u = navigator.userAgent,
    //       app = navigator.appVersion;
    //     let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //     let isOS = isAndroid ? true : false;
    //     // console.log(isOS);
    //     if (isOS) {
    //       // console.log(filename, '-android');
    //       window.Android.popups(linkUrl, title, desc, imgUrl, shareType);
    //     } else {
    //       window.webkit.messageHandlers.popups.postMessage({
    //         cypher: linkUrl,
    //         title: title,
    //         Introduction: desc,
    //         imgUrl: imgUrl,
    //         shareType: shareType
    //       });
    //     }
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.btn-group {
  display: flex;
  width: 100%;
  height: auto;
  position: relative;
  justify-content: space-around;
  margin-top: -78px;
  img {
    width: 150px;
    height: auto;
  }
}
// .van-tabs--line {
//   /deep/.van-tabs__wrap {
//     height: 49px;
//     top: 42px;
//     position: fixed;
//     z-index: 2013;
//     width: 100%;
//     .van-tab {
//       line-height: 49px;
//     }
//   }
//   /deep/.van-tabs__content {
//     height: 100%;
//     min-height: 680px;
//     background: #2376ff;
//     margin-top: 47px;
//   }
//   // .tab_join{
//   //   height: fit-content;
//   // }
//   // /deep/.van-tab__pane-wrapper--inactive{
//   //   height: fit-content;
//   // }
//   .divs {
//     width: 100%;
//     height: 54px;
//     background: #2376ff;
//   }
//   .bg {
//     height: 90px;
//   }
//   .tabsA {
//     .banners {
//       width: 100%;
//       height: 111px;
//     }
//     .banners2 {
//       width: 100%;
//       height: 213px;
//     }
//     .lists {
//       width: 333px;
//       height: 73px;
//       background: rgba(255, 255, 255, 1);
//       border-radius: 5px;
//       margin: 15px auto 12px;
//       display: flex;
//       align-items: center;
//       img {
//         width: 70px;
//         height: 65px;
//         display: block;
//         margin: 0 20px 0 15px;
//         flex-shrink: 0;
//       }
//       p {
//         font-size: 16px;
//         color: #0f5bd9;
//         text-align: left;
//       }
//     }
//     .texts {
//       height: 340px;
//       width: 333px;
//       background: rgba(255, 255, 255, 1);
//       border-radius: 5px;
//       margin: 0 auto;
//       p {
//         text-align: left;
//         margin: 0 0 0 14px;
//       }
//       p:first-child {
//         padding-top: 26px;
//       }
//       p:nth-child(odd) {
//         color: #ff8314;
//         font-size: 16px;
//         font-weight: bold;
//       }
//       p:nth-child(even) {
//         color: #0f5bd9;
//         font-size: 14px;
//         line-height: 21px;
//         margin: 8px 0 14px 14px;
//       }
//     }
//   }
// }
// .btn {
//   width: 333px;
//   height: 44px;
//   opacity: 0.9;
//   border-radius: 22px;
//   color: #fff;
//   font-size: 19px;
//   font-weight: bold;
//   position: fixed;
//   z-index: 2013;
//   left: 0;
//   right: 0;
//   margin: 0 auto;
//   bottom: 7px;
// }
// /deep/.van-overlay {
//   z-index: 3333 !important;
// }
// .shareModel {
//   width: 100%;
//   height: 293px;
//   overflow: hidden;
//   z-index: 3333 !important;
//   .shareText {
//     font-size: 14px;
//     color: #666;
//     text-align: center;
//     width: 100%;
//     height: 72px;
//     line-height: 72px;
//     background: rgba(245, 245, 245, 1);
//     margin: 0;
//   }

//   .shares {
//     width: 100%;
//     height: 172px;
//     border-bottom: 1px solid #d9d9d9;
//     .shareOther {
//       color: #333;
//       font-size: 18px;
//       font-weight: bold;
//       margin: 0;
//       padding: 12px 0;
//     }
//     .shareList {
//       display: flex;
//       div {
//         width: 73px;
//         height: 91px;
//         text-align: center;
//         flex: 1;
//         img {
//           width: 61px;
//           height: 61px;
//         }
//         p {
//           color: #666;
//           font-size: 14px;
//           margin: 0;
//         }
//       }
//       //   div:first-child{
//       //       margin: 0
//       //   }
//     }
//   }
//   .close {
//     width: 100%;
//     height: 49px;
//     line-height: 49px;
//     border: 0;
//     font-size: 16px;
//     color: #333;
//     display: block;
//   }
// }
// .wrapper {
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 100%;
// }

// .block {
//   img {
//     width: 247px;
//     height: 115px;
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     margin: 0 auto;
//   }
//   .btns {
//     width: 193px;
//     height: 54px;
//     border: 1px solid rgba(255, 255, 255, 1);
//     border-radius: 25px;
//     font-size: 23px;
//     color: #fff;
//     line-height: 54px;
//     margin-top: 200px;
//   }
// }
// /deep/.van-hairline--top-bottom::after {
//   border-width: 0;
// }
</style>